export let attributeName = "data-testid"

export const getTransform = (value) => {
  return { [value]: { [attributeName]: value?.replaceAll("_", "-") } }
}

export const doAddOnTestIdKendoHeader = (refTableKit, moduleName) => {

  let doAddOnTableHeader = () => {
    let tempElm = refTableKit?.current?.querySelector(".k-grid-header-wrap")
    let tempTrHeading = tempElm?.querySelector(
      'tr[role="row"][aria-rowindex="1"]'
    )
    let tempAllColumHeading = tempTrHeading?.querySelectorAll(".k-header") || []
    if (tempAllColumHeading.length > 0) {
      tempAllColumHeading.forEach((colItem, index) => {
        let indexKit = index + 1
        let valueKit = colItem?.querySelector(".k-column-title")?.textContent
        valueKit = valueKit?.toLowerCase()
        valueKit = valueKit?.replaceAll(" ", "-")
        let filterTestIdValue = `dk-kendo-header-${valueKit}-filter-input`
        let filterClearTestIdValue = `dk-kendo-header-${valueKit}-filter-clear`
        let filterSortTestIdValue = `dk-kendo-header-${valueKit}-filter-sort`
        let checkboxTestIdValue = `dk-kendo-header-selectall-${moduleName}-checkbox-input`

        let filterInput = refTableKit?.current?.querySelector(
          `.k-filter-row[aria-rowindex="2"] th[aria-colindex="${indexKit}"] input`
        )
        let filterClear = refTableKit?.current?.querySelector(
          `.k-filter-row[aria-rowindex="2"] th[aria-colindex="${indexKit}"] .k-filtercell-operator .k-button.k-button-icon`
        )
        if (filterInput) {
          filterInput?.setAttribute(attributeName, filterTestIdValue)
        }
        if (filterClear) {
          filterClear?.setAttribute(attributeName, filterClearTestIdValue)
        }

        let sortField = colItem?.querySelector(".k-link")
        if (sortField) {
          sortField.setAttribute(attributeName, filterSortTestIdValue)
        }
        let checkboxHeaderInput = colItem?.querySelector(".k-checkbox")
        if (checkboxHeaderInput) {
          checkboxHeaderInput.setAttribute(attributeName, checkboxTestIdValue)
        }
      })
    }
  }
  let doAddOnTablePagination = () => {
    let tempElm = refTableKit?.current?.querySelector(".k-pager-wrap")
    let pagerLeftFirstElem = tempElm?.querySelector(
      '[title="Go to the first page"]'
    )
    let pagerLeftPreviousElem = tempElm?.querySelector(
      '[title="Go to the previous page"]'
    )
    let pagerRightNextElem = tempElm?.querySelector(
      '[title="Go to the next page"]'
    )
    let pagerRightLastElem = tempElm?.querySelector(
      '[title="Go to the last page"]'
    )
    let pagerNumberAllElem = tempElm?.querySelectorAll(
      ".k-pager-numbers a.k-link"
    )

    if (pagerLeftFirstElem) {
      pagerLeftFirstElem.setAttribute(
        attributeName,
        `dk-kendo-pager-first-button`
      )
    }
    if (pagerLeftPreviousElem) {
      pagerLeftPreviousElem.setAttribute(
        attributeName,
        `dk-kendo-pager-previous-button`
      )
    }
    if (pagerRightNextElem) {
      pagerRightNextElem.setAttribute(
        attributeName,
        `dk-kendo-pager-next-button`
      )
    }
    if (pagerRightLastElem) {
      pagerRightLastElem.setAttribute(
        attributeName,
        `dk-kendo-pager-last-button`
      )
    }

    if (pagerNumberAllElem) {
      pagerNumberAllElem?.forEach((pagerNumberElem, index) => {
        let indexKit = index + 1
        let content = pagerNumberElem.textContent?.replaceAll("...", "more")
        pagerNumberElem.setAttribute(
          attributeName,
          `dk-kendo-pager-number-${content}-frame${indexKit}-link`
        )
      })
    }
  }

  if (refTableKit?.current) {
    doAddOnTableHeader()
    doAddOnTablePagination()
  }
}

export const doAddOnTestIdSideBar = (nameKit = "null") => {
  let testId = {}
  testId[attributeName] = `dk-sidebar-${nameKit}-link`

  return testId
}

export const doAddOnTestIdCommonDropdownFilter = (ref = {}, props = {}) => {
  if (ref?.current) {
    let modifyString = props?.placeholder || "Select Common Dropdown"
    modifyString = modifyString?.toLowerCase()?.replaceAll(" ", "-")
    ref?.current
      ?.querySelector("button.MuiAutocomplete-popupIndicator")
      ?.setAttribute(attributeName, `dk-common-${modifyString}-chevron-button`)
  }
}

export const doAddOnTestIdKendoCheckbox = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-kendo-common-row-${testIdValue}-checkbox-input`
  }

  return testId
}

export const doAddOnTestIdCommonDropdownFilterRenderOption = (
  modifyString = ""
) => {
  let testIdInject = {}
  testIdInject[attributeName] = `dk-common-${modifyString}-options`
  return testIdInject
}
export const doAddOnTestIdCommonDropdownFilterError = (
  ref = {},
  props = {}
) => {
  if (ref?.current) {
    let modifyString = props?.placeholder || "Select Common Dropdown"
    modifyString = modifyString?.toLowerCase()?.replaceAll(" ", "-")
    let errorElem = ref?.current?.querySelector("p.Mui-error")
    if (errorElem) {
      errorElem?.setAttribute(
        attributeName,
        `dk-dropdown-common-${modifyString}-error`
      )
    }
  }
}

export const doAddOnTestIdKendoActionMenuEditIcon = (testIdValue = "null",type="edit") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-${type}-icon`
  }

  return testId
}

export const doAddOnTestIdKendoMenuViewIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-view-icon`
  }

  return testId
}

export const doAddOnTestIdKendoMenuSaveIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-save-icon`
  }

  return testId
}

export const doAddOnTestIdKendoMenuCancelIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-cancel-icon`
  }

  return testId
}

export const doAddOnTestIdKendoMenuDeleteIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-delete-icon`
  }

  return testId
}

export const doAddOnTestIdCommonAutoCompleteDropdown = (refElem, props) => {
  if (refElem?.current) {
    let name = props?.placeholder
    name = props?.placeholder?.toLowerCase()
    name = props?.placeholder?.replaceAll(" ", "-")
    refElem?.current?.setAttribute(
      attributeName,
      `dk-common-parent-${name}-acdropdown`
    )
    refElem?.current
      ?.querySelector("#id-detailedTransactionReport-common")
      ?.setAttribute(attributeName, `dk-common-${name}-acdropdown`)
  }
}

export const doAddOnTestIdCustomFilterCellKendo = (refElem, props) => {
  if (refElem?.current) {
    let name = props?.field
    name = props?.field?.toLowerCase()
    name = props?.field?.replaceAll(" ", "-")

    const domNode = refElem.current.wrapper || refElem.current.element || refElem.current.input

    if (domNode && domNode.setAttribute) {
      domNode?.setAttribute(
        attributeName,
        `dk-common-parent-${name}-custom-filtercell-dropdown`
      )
    }
  }
}

export const doAddOnTestIdCommonAutoCompleteDropdownItemCheckBox = (value) => {
  let testId = {}

  if (value) {
    testId[
      attributeName
    ] = `dk-common-${value}-AutoCompleteDropdownItem-checkbox`
  }

  return testId
}

export const doAddOnTestIdCommonDropdownKitItem = (value) => {
  let testId = {}

  if (value) {
    testId["data-testid"] = `dk-common-${value}-dropdownkit-option`
  }
  return testId
}

export const doAddOnTestIdCustomizedSteppers = (value) => {
  let testId = {}

  if (value) {
    testId[attributeName] = `dk-common-${value}-customized-steppers`
  }

  return testId
}

export const doAddOnTestIdConfirmationDialog = (value) => {
  let testId = {}

  if (value) {
    testId[
      attributeName
    ] = `dk-common-${value}-confirmation-dialog-action-button`
  }

  return testId
}

export const doAddOnTestIdCommonMultiChipKit = (value) => {
  let testId = {}

  if (value) {
    testId[attributeName] = `dk-common-multiChipKit-${value}`
  }

  return testId
}

export const doAddOnTestIdCommonFacetUIKit = (value) => {
  let testId = {}

  if (value) {
    testId[attributeName] = `dk-common-facetuikit-${value}`
  }

  return testId
}

export const doAddOnContentCreateBtnTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-content-${testIdValue}-create-button`
  }
  return testId
}

export const doAddOnKendoInlineEditTestID = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-kendo-inline-edit-${testIdValue}-input`
  }
  return testId
}


export const doAddOnTableHeaderActionTestID = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-kendo-table-header-${testIdValue}`
  }
  return testId
}

export const doAddOnCommonCardViewTestID = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-common-card-view-${testIdValue}`
  }
  return testId
}

export const doAddOnTestIdKendoMenuStopIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-stop-icon`
  }

  return testId
}

export const doAddOnTestIdKendoCancelStopIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-cancel-icon`
  }

  return testId
}

export const doAddOnTestIdKendoSaveStopIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-cancel-icon`
  }

  return testId
}

export const doAddOnTestIdKendoCopyStopIcon = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId[attributeName] = `dk-sidebar-${testIdValue}-copy-icon`
  }

  return testId
}



